import '../sass/introduction.scss';

const WORD = 'word';
const VIS = 'word--visible';
/** Reveal completes when the bottom of the text hits this viewport fraction (not the top edge). */
const REVEAL_END = 0.65;

function wrapWordsInElement(root) {
	const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
	const nodes = [];
	let n;
	while ((n = w.nextNode())) {
		if (!n.textContent.trim()) continue;
		const p = n.parentElement;
		if (!p || p.closest('script, style')) continue;
		nodes.push(n);
	}
	for (const t of nodes) {
		const frag = document.createDocumentFragment();
		for (const part of t.textContent.split(/(\s+)/)) {
			if (!part) continue;
			if (/^\s+$/.test(part)) frag.appendChild(document.createTextNode(part));
			else {
				const s = document.createElement('span');
				s.className = WORD;
				s.textContent = part;
				frag.appendChild(s);
			}
		}
		t.parentNode.replaceChild(frag, t);
	}
}

/** Progress from block entering viewport (top vs bottom edge); words light in DOM order. */
function bindWordRevealOnScroll(el) {
	let lock = false;
	const reveal = () => {
		const words = el.querySelectorAll(`.${WORD}`);
		const n = words.length;
		if (!n) return;

		const vh = window.innerHeight;
		const r = el.getBoundingClientRect();

		if (r.bottom < 0) {
			words.forEach((w) => w.classList.add(VIS));
			return;
		}
		if (r.top > vh) {
			words.forEach((w) => w.classList.remove(VIS));
			return;
		}

		// 0 when the block enters; 1 when its bottom reaches REVEAL_END down the viewport.
		const enterBottom = vh + r.height;
		const endBottom = vh * REVEAL_END;
		const scrollSpan = enterBottom - endBottom;
		const p = Math.min(1, Math.max(0, (enterBottom - r.bottom) / scrollSpan));
		const k = Math.floor(p * n + 1e-9);
		words.forEach((w, i) => w.classList.toggle(VIS, i < k));
	};

	const tick = () => {
		if (lock) return;
		lock = true;
		requestAnimationFrame(() => {
			reveal();
			lock = false;
		});
	};

	window.addEventListener('scroll', tick, { passive: true });
	window.addEventListener('resize', tick);
	reveal();
}

const init = () =>
	document.querySelectorAll('.introduction__text').forEach((el) => {
		wrapWordsInElement(el);
		bindWordRevealOnScroll(el);
	});

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
